import type { AcademyPathKey } from '../../../pages/academy/Academy/AcademyService';
import assignmentOutlinedIconUrl from './Images/assignment-outlined.svg';
import lightbulbOutlinedIconUrl from './Images/lightbulb-outlined.svg';
import searchOutlinedIconUrl from './Images/search-outlined.svg';

const academyPathIconUrls: Record<AcademyPathKey, string> = {
  plan_prepare: assignmentOutlinedIconUrl,
  teach_facilitate: lightbulbOutlinedIconUrl,
  assess_adjust: searchOutlinedIconUrl,
};

export function getAcademyPathIconUrl(pathKey: AcademyPathKey | string): string {
  return academyPathIconUrls[pathKey as AcademyPathKey] || assignmentOutlinedIconUrl;
}
